import {useApplication} from '../../providers/ApplicationProvider';
import {observer} from 'mobx-react';
import useFeature from '../../hooks/useFeature';
import NewMedicalConsultationWizardFeature from "../../features/NewMedicalConsultationWizardFeature";
import PatientIdStep from "./PatientIdStep";
import CreatePatientStep from "./CreatePatientStep";
import WizardComponent from "../../libs/wizards/WizardComponent";
import {useLocation, useNavigate} from "react-router-dom";
import SymptomsStep from './SymptomsStep';
import RisksFactorsStep from "./RisksFactorsStep";
import FamilyHistoryStep from "./FamilyHistoryStep";
import InformationSummaryStep from "./InformationSummaryStep";

function NewMedicalConsultationWizardScreen() {
  const application = useApplication();
  const navigator = useNavigate();
  const location = useLocation();
  const identificationNumber = location.state && location.state.identificationNumber ? location.state.identificationNumber : undefined;
  const feature = useFeature(() => new NewMedicalConsultationWizardFeature(application, navigator, identificationNumber));
  const style = styles();

  return feature && (
    <section style={style.mainContainer}>
      <WizardComponent
        steps={[PatientIdStep, CreatePatientStep, SymptomsStep, RisksFactorsStep, FamilyHistoryStep, InformationSummaryStep]}
        wizard={feature.wizard}/>
    </section>
  );

}

export default observer(NewMedicalConsultationWizardScreen);

const styles = () => ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem',
  }
});